/**
 * Explicitly opt-out of using formKey within a KtFormContext
 */
export const FORM_KEY_NONE = 'NONE'
